import { Component, OnInit } from '@angular/core';
import { Location } from '@angular/common';
import { Router } from '@angular/router';
import { ControlFormsService } from '@core/services/control-forms/control-forms.service';

@Component({
  selector: 'app-success',
  templateUrl: './success.component.html',
  styleUrls: ['./success.component.scss'],
})
export class SuccessComponent implements OnInit {
  responseService: any;
  constructor(
    private readonly _location: Location,
    private readonly router: Router,
    private readonly accessControlService: ControlFormsService
  ) {}

  ngOnInit() {
    this.dataError(this.router.url);
    if (!this.accessControlService.isAccessAllowed()) {
      this.router.navigate(['/seleccionar-cliente']);
    }
    this.accessControlService.resetAccess();
  }
  goBack() {
    this._location.back();
  }
  dataError(error) {
    this.responseService = {
      img: 'assets/svg/spot-not-found.svg',
      button: false,
      title: '¡Listo! Tu formulario ha sido enviado correctamente',
    };
  }
}
